/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import FormatUrl from "../../utils/UrlFormatter";
// import { ClinicContext } from "../../context/ClinicContext"
import { getClinicId } from "../../utils/config";
import './Login.css'; 

const Login = ({ account, success, user }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  // const { setClinicId, setClinicName } = useContext(ClinicContext);

  const [username, setUsername] = useState(null);
  // const [password, setPassword] = useState(null);
  const [loginType, setLoginType] = useState('phone'); 
  const [otp, setOtp] = useState(null); 
  const [phone, setPhone] = useState(null); 
  const [otpId, setOtpId] = useState(null); 
  const [otpEnabled, setOtpEnabled] = useState(false);
  const [errorMsg, SetErrorMsg] = useState(null);

  // Function to toggle login type (username/password vs phone/OTP)
  const toggleLoginType = () => {
    setLoginType(loginType === 'phone' ? 'username' : 'phone');
    SetErrorMsg(null);
  };

  // Function to fetch the CSRF token (shared between login and requestOtp)
  const fetchCsrfToken = async () => { 
    const csrfUrl = FormatUrl(`/csrf-token/`);
    const csrfResponse = await fetch(csrfUrl, {
      method: 'GET',
      credentials: 'include', 
    });

    if (!csrfResponse.ok) {
      throw new Error('Failed to fetch CSRF token');
    }

    const csrfData = await csrfResponse.json();
    return csrfData.csrfToken;
  };

  // Function to handle login (either with username/password or phone/OTP)
  const login = async (ev) => {
    ev.preventDefault();
    
   // Validation logic based on login type
    if (loginType === "username") {
      if (!username) {
        SetErrorMsg(t("login.username_required"));
        return;
      }
      if (!otp) { // Email OTP validation
        SetErrorMsg(t("login.otp_required"));
        return;
      }
      if (!otpId) {
        SetErrorMsg(t("login.otp_id_missing"));
        return;
      }
    } else {
      if (!phone) {
        SetErrorMsg(t("login.phone_required"));
        return;
      }
      if (!otp) {
        SetErrorMsg(t("login.otp_required"));
        return;
      }
      if (!otpId) {
        SetErrorMsg(t("login.otp_id_missing"));
        return;
      }
    }

    try {
      // Fetch CSRF token

      const csrfToken = await fetchCsrfToken();

      let formData = new FormData();

      if (loginType === 'username') {
        formData.append("username", username);
        formData.append("password", otpId + ',' + otp); 
      } else {
        // formData.append("username", phone);
        formData.append("username", `+1${phone}`);
        formData.append("password", otpId + ',' + otp); 
      }

      const clinicId = getClinicId(user);
      if (clinicId) {
        formData.append("clinic_id", clinicId);
      }

      let requestOptions = {
        method: 'POST',
        headers: {
          "X-CSRFToken": csrfToken, 
        },
        body: formData,
        credentials: 'include',
        redirect: 'follow'
      };

      let loginUrl = FormatUrl(`/login/`);
      const loginResponse = await fetch(loginUrl, requestOptions);

      if (!loginResponse.ok) {
        const errorText = await loginResponse.text()
        console.error("Login Error Response:", errorText); 
        throw new Error(t("login.login_failed"));
      }

      const loginData = await loginResponse.json();

      if (loginData.status === "success") {
        // Check if the user role is Clinic Admin (CA) or Doctor (DO)
        if (loginData.role === "CA" || loginData.role === "DO") {
          localStorage.setItem("clinic_id", loginData.clinic_id);
          localStorage.setItem("clinic_name", loginData.clinic_name);
        }
        if (loginData.role) {
          localStorage.setItem("userRole", loginData.role);
        }
        // Proceed with the success callback regardless of the role
        success(loginData);
        navigate('/')
      } else {
        SetErrorMsg(t("login.invalid_credentials"));
      }      
    } catch (error) {
      SetErrorMsg(t("login.login_error"));
    }
  };

  // Function to request OTP (triggered when user clicks a button to request OTP)
  const requestOtp = async () => {
    if ((loginType === 'phone' && !phone) || (loginType === 'username' && !username)) {
      SetErrorMsg(t("login.phone_required_otp"));
      return;
    }

    try {
      // Fetch CSRF token

      const csrfToken = await fetchCsrfToken(); 
      let formData = new FormData();
      if (loginType === 'phone') {
        // formData.append("phone", phone);
        formData.append("phone", `+1${phone}`);
      } else {
        formData.append("email", username); 
      }

      let requestOptions = {
        method: 'POST',
        headers: {
          "X-CSRFToken": csrfToken, 
        },
        body: formData,
        credentials: 'include',
      };

      let otpUrl = FormatUrl(`/request-otp/`);
      const otpResponse = await fetch(otpUrl, requestOptions);

      if (!otpResponse.ok) {
        const errorText = await otpResponse.text();
        console.error("OTP Request Error Response:", errorText); 
        throw new Error(t("login.otp_request_failed"));
      }

      const otpData = await otpResponse.json();
      setOtpId(otpData.otpId); // Store OTP ID for later use
      setOtpEnabled(true);
      SetErrorMsg(t("login.otp_sent_success"));
    } catch (error) {
      SetErrorMsg(t("login.otp_request_error"));
    }
  };

  // Function to check if phone number is valid (contains only digits and reasonable length)
const isPhoneValid = (phone) => {
    const phoneRegex = /^[0-9]{10,15}$/;  
    return phoneRegex.test(phone);
  };
  
  // Function to check if email is valid (basic email validation)
  const isEmailValid = (email) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };
  
  // Update the "Request OTP" button enabling logic
  const isRequestOtpEnabled = () => {
    if (loginType === 'phone') {
      return phone && isPhoneValid(phone); 
    }
    if (loginType === 'username') {
      return username && isEmailValid(username); 
    }
    return false; // Default case
  };

  
  return (
    <div className="fancy-login-popup-area fancy-signin-popup-box">
      <div className="fancy-login-popup">
        <span className="fancy-close-popup" onClick={() => account(0)}>
          <i className="fa fa-times" aria-hidden="true"></i>
        </span>
        <h3>{t("login.login")}</h3>

        <div className="fancy-toggle-container">
          <label className="fancy-toggle-label">
            <input
              type="checkbox"
              className="fancy-toggle-input"
              onChange={toggleLoginType}
              checked={loginType === 'username'}
            />
            <span className="fancy-toggle-slider"></span>
            <span className="fancy-toggle-text">
              {loginType === 'phone' 
                ? t("login.login_with_phone_otp") 
                : t("login.login_with_username_password")}
            </span>
          </label>
        </div>

        <form onSubmit={login}>
          {loginType === 'phone' ? (
            <>
              {/* <div className="fancy-cfield">
                <input type="text" placeholder={t("login.phone_number")} onChange={(ev) => setPhone(ev.target.value)} />
                <i className="fa fa-phone" aria-hidden="true"></i>
              </div> */}
                <div className="fancy-cfield phone-input-split">
                  <span className="phone-prefix-login">+1</span>
                  <input
                    type="text"
                    placeholder={t("login.phone_number")}
                    maxLength={10}
                    value={phone || ''}
                    onChange={(ev) => {
                      const numeric = ev.target.value.replace(/\D/g, '');
                      setPhone(numeric);
                    }}
                  />
              </div>
              
              <div className="fancy-cfield">
              <button
                type="button"
                className="fancy-btn-request-otp"
                onClick={requestOtp}
                disabled={!isRequestOtpEnabled()} 
                >
                {t("login.request_otp")}
                </button>

              </div>
              <div className="fancy-cfield">
                <input
                  type="text"
                  placeholder= {t("login.otp")}
                  onChange={(ev) => setOtp(ev.target.value)}
                  disabled={!otpEnabled} 
                />
                 <i 
                  className={`fa ${otpEnabled ? 'fa-unlock' : 'fa-lock'}`} 
                  aria-hidden="true">
                </i>
              </div>
            </>
          ) : (
            <>
              <div className="fancy-cfield">
                <input type="email" placeholder={t("login.email")} onChange={(ev) => setUsername(ev.target.value)} />
                <i className="fa fa-user-circle" aria-hidden="true"></i>
              </div>
              <div className="fancy-cfield">
              <button
                type="button"
                className="fancy-btn-request-otp"
                onClick={requestOtp}
                disabled={!isRequestOtpEnabled()} 
                >
                {t("login.request_otp")}
                </button>

              </div>
              <div className="fancy-cfield">
                <input
                  type="text"
                  placeholder= {t("login.otp")}
                  onChange={(ev) => setOtp(ev.target.value)}
                  disabled={!otpEnabled} // Disable until "Request OTP" is clicked
                />
                <i 
                  className={`fa ${otpEnabled ? 'fa-unlock' : 'fa-lock'}`} 
                  aria-hidden="true">
                </i>
              </div>
            </>
          )}

          {errorMsg && <p className="fancy-error-msg">{errorMsg}</p>}

          <button className="fancy-btn" type="submit">{t("login.login")}</button>
        </form>
      </div>
    </div>
  )
}

export default Login;
